import { render, staticRenderFns } from "./UserNameBadges.vue?vue&type=template&id=a2fe2518&scoped=true"
import script from "./UserNameBadges.vue?vue&type=script&lang=js"
export * from "./UserNameBadges.vue?vue&type=script&lang=js"
import style0 from "./UserNameBadges.vue?vue&type=style&index=0&id=a2fe2518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fe2518",
  null
  
)

export default component.exports